import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { getValues, prepareValues } from '@/lib/values'

export const room_edit = {

  namespaced: true,

  state: {
    values: {},
    entities: [],
  },

  getters: {
    values: state => state.values,
    entities: state => state.entities,
  },

  mutations: {
    setValues(state, values) { state.values = values },
    setEntities(state, entities) { state.entities = entities },
  },

  actions: {

    getEntities: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Room'],
      form_display: true,
    }}),

    async getForm({ commit, dispatch }) {
      commit('clearResponse', {}, { root: true });
      commit('setEntities', []);
      const entities = await dispatch('getEntities');
      commit('setProgress', false, { root: true });
      commit('setValues', getValues('room', entities.data['App\\Models\\Room'], 'content'));
      commit('setEntities', entities.data['App\\Models\\Room']);
    },

    async validateRoom({ state, rootState, commit, dispatch }) {
      if (!rootState.progress) {
        try {
          await Vue.axios.post(API_URL + '/validate?model=App\\Models\\Room', state.values, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
        } catch (error) {
          commit('setProgress', false, { root: true });
          commit('setResponse', { status: true, type: 'error', message: 'form_error', errors: error.response.data.errors }, { root: true });
          return;
        }
        let values = prepareValues(state.values, state.entities, 'content_');
        dispatch(((!router.currentRoute.params.id) ? 'create' : 'update') + 'Room', values);
      }
    },

    async createRoom({ commit }, values) {
      const rooms = await Vue.axios.get(API_URL + '/rooms', { params: { sorts: [{"column":"id","order":"asc"}] }});
      values.order = rooms.data.items.length ? rooms.data.items.pop().order + 1 : 1;
      const response = await Vue.axios.post(API_URL + '/rooms', values);
      commit('setProgress', false, { root: true });
      router.push('/room/' + response.data.id + '/edit');
      commit('setResponse', { status: true, type: 'success', message: 'room_successfully_created' }, { root: true });
    },

    async updateRoom({ state, commit }, values) {
      const room = await Vue.axios.put(API_URL + '/rooms/' + router.currentRoute.params.id, values);
      commit('room/setRoom', room.data, { root: true });
      commit('setValues', getValues('room', state.entities, 'content'));
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'room_successfully_updated' }, { root: true });
    },

  }
}
